/* global alert */
import constants from '../constants.json' assert { type: 'json' };

export default function protectCopyRight(e) {
    e.preventDefault();
    alert(constants.COPYRIGHT_ALERT_MESSAGE);
}